function hasProductsWithSpecialOfferRatePlan(products) {
  const hasSpecialOfferRatePlan = Object.values(products).some((product) => {
    const { rate_plans: ratePlans } = product;

    // Are renewals always service_activation vs contract_effective
    const hasSpecialPrice = ratePlans.some(({ prices }) => {
      // Base rate plan prices are contract_effective like business as usual (BAU)
      // monthly or yearly price. Presence of service activation implies step pricing
      // so moving from a special discounted offer price (e.g., after 3 months) to a business
      // as usual price.
      const hasSpecialOfferPrice = prices.some(
        ({ start_event }) => start_event === 'service_activation',
      );

      return hasSpecialOfferPrice;
    });

    return hasSpecialPrice;
  });

  return hasSpecialOfferRatePlan;
}

export default hasProductsWithSpecialOfferRatePlan;
